export const chatWithDocsSteps = [
  {
    title: 'Upload Your Document',
    description:
      'Simply upload your document, and let AI process the content to assist you with accurate insights',
    lightImage: '/steps/cwd-light-1.png',
    darkImage: '/steps/cwd-dark-1.png',
  },
  {
    title: 'Chat & Refine',
    description:
      'Ask questions, get instant responses, and refine the information to suit your needs.',
    lightImage: '/steps/cwd-light-2.png',
    darkImage: '/steps/cwd-dark-2.png',
  },
  {
    title: 'Save for Later',
    description:
      'Easily copy key insights, save important details, or share them wherever needed.',
    lightImage: '/steps/cwd-light-3.png',
    darkImage: '/steps/cwd-dark-3.png',
  },
];

export const blogWriterSteps = [
  {
    title: 'Enter your Prompt',
    description:
      'Set the tone, choose your style, and let AI craft a blog that perfectly aligns with your brand.',
    lightImage: '/steps/bw-light-1.png',
    darkImage: '/steps/bw-dark-1.png',
  },
  {
    title: 'Edit & Refine',
    description:
      'Fine-tune, adjust, and personalize your content with our flexible built-in editing tools.',
    lightImage: '/steps/bw-light-2.png',
    darkImage: '/steps/bw-dark-2.png',
  },
  {
    title: 'Team Up',
    description:
      'Collaborate seamlessly—share, gather feedback, and co-create with your team.',
    lightImage: '/steps/bw-light-3.png',
    darkImage: '/steps/bw-dark-3.png',
  },
  {
    title: 'Save & Share',
    description:
      'Easily save or download your file in high quality, ready to use wherever you need.',
    lightImage: '/steps/bw-light-4.png',
    darkImage: '/steps/bw-dark-4.png',
  },
];

export const botBuilderSteps = [
  {
    title: 'Set-up your Bot',
    description:
      'Enter the Telegram Bot Token along with your bot’s name and description.',
    lightImage: '/steps/bb-light-1.svg',
    darkImage: '/steps/bb-dark-1.svg',
  },
  {
    title: 'Choose Features',
    description:
      'Pick the features you need, adjust settings, and tailor the bot to your needs.',
    lightImage: '/steps/bb-light-2.svg',
    darkImage: '/steps/bb-dark-2.svg',
  },
  {
    title: 'Generate & Launch',
    description:
      'Click on Crete Telegram Bot to make your bot live and start using it instantly.',
    lightImage: '/steps/bb-light-3.svg',
    darkImage: '/steps/bb-dark-3.svg',
  },
];

export const emailGeneratorSteps = [
  {
    title: 'Enter your Prompt',
    description:
      'Choose the purpose, set the tone, and let AI craft an email that effectively conveys your message.',
    lightImage: '/steps/ew-light-1.png',
    darkImage: '/steps/ew-dark-1.png',
  },

  {
    title: 'Edit & Refine',
    description:
      'Fine-tune, adjust, and personalize your content with our flexible built-in editing tools.',
    lightImage: '/steps/ew-light-2.png',
    darkImage: '/steps/ew-dark-2.png',
  },
  {
    title: 'Copy & Share',
    description:
      'Directly copy the email and send it with ease, or download and post it across platforms seamlessly.',
    lightImage: '/steps/ew-light-3.png',
    darkImage: '/steps/ew-dark-3.png',
  },
];

export const textToImageSteps = [
  {
    title: 'Describe your Image',
    description:
      'Enter a prompt or let AI generate one, then choose a style to bring your idea to life.',
    lightImage: '/steps/image-light-1.svg',
    darkImage: '/steps/image-dark-1.svg',
  },
  {
    title: 'Fine-Tune the Details',
    description:
      'Enhance your image by upscaling, removing elements, or making precise adjustments.',
    lightImage: '/steps/image-light-2.svg',
    darkImage: '/steps/image-dark-2.svg',
  },
  {
    title: 'Save & Share with Ease',
    description:
      'Download your final creation or seamlessly share it wherever you need.',
    lightImage: '/steps/image-light-3.svg',
    darkImage: '/steps/image-dark-3.svg',
  },
];

export const textToLogoSteps = [
  {
    title: 'Define your Brand',
    description:
      'Enter your brand name, industry, and style preferences to set the direction for your logo.',
    lightImage: '/steps/logo-light-1.png',
    darkImage: '/steps/logo-dark-1.png',
  },
  {
    title: 'Refine with Smart Suggestions',
    description:
      'Enhance your logo by exploring alternative icons, colors, or styles with AI-powered prompts.',
    lightImage: '/steps/logo-light-2.png',
    darkImage: '/steps/logo-dark-2.png',
  },
  {
    title: 'Save & Use Instantly',
    description:
      'Download your high-quality logo and start applying it across your brand assets.',
    lightImage: '/steps/logo-light-3.png',
    darkImage: '/steps/logo-dark-3.png',
  },
];

export const gifMakerSteps = [
  {
    title: 'Upload your Image',
    description:
      'Select a single image file to transform into an animated GIF effortlessly.',
    lightImage: '/steps/gif-light-1.png',
    darkImage: '/steps/gif-dark-1.png',
  },
  {
    title: 'Let AI Add Motion',
    description:
      'AI will intelligently animate your image with seamless effects and transitions.',
    lightImage: '/steps/gif-light-2.png',
    darkImage: '/steps/gif-dark-2.png',
  },
  {
    title: 'Save & Download',
    description:
      'Save your GIF and use it anywhere—on social media, websites, or messages.',
    lightImage: '/steps/gif-light-3.png',
    darkImage: '/steps/gif-dark-3.png',
  },
];

export const transcriptGeneratorSteps = [
  {
    title: 'Upload Media ',
    description:
      'Select and upload your audio or video file to start the transcription process.',
    lightImage: '/steps/transcript-light-1.png',
    darkImage: '/steps/transcript-dark-1.png',
  },
  {
    title: 'Generate & Edit',
    description:
      'Automatically convert your media into text, then review and refine for clarity.',
    lightImage: '/steps/transcript-light-2.png',
    darkImage: '/steps/transcript-dark-2.png',
  },
  {
    title: 'Download & Save',
    description:
      'Once finalized, download and store your transcript for easy access.',
    lightImage: '/steps/transcript-light-3.png',
    darkImage: '/steps/transcript-dark-3.png',
  },
];

export const textToSpeechSteps = [
  {
    title: 'Enter your Script',
    description:
      'Type or paste the text you want to bring to life with speech.',
    lightImage: '/steps/tts-light-1.png',
    darkImage: '/steps/tts-dark-1.png',
  },
  {
    title: 'Choose a Voice',
    description: 'Select a voice that matches the tone and style you need.',
    lightImage: '/steps/tts-light-2.png',
    darkImage: '/steps/tts-dark-2.png',
  },
  {
    title: 'Generate & Save',
    description:
      'Instantly convert your text into speech and download or share with ease.',
    lightImage: '/steps/tts-light-3.png',
    darkImage: '/steps/tts-dark-3.png',
  },
];

export const upscaleImageSteps = [
  {
    title: 'Upload your Image',
    description:
      'Select an image to enhance and improve its resolution without losing quality.',
    lightImage: '/steps/upscale-light-1.png',
    darkImage: '/steps/upscale-dark-1.png',
  },
  {
    title: 'Enhance with AI',
    description:
      'Automatically upscale your image for sharper details and improved clarity',
    lightImage: '/steps/upscale-light-2.png',
    darkImage: '/steps/upscale-dark-2.png',
  },
  {
    title: 'Download & Use',
    description:
      'Save your high-resolution image for professional or personal use.',
    lightImage: '/steps/upscale-light-3.png',
    darkImage: '/steps/upscale-dark-3.png',
  },
];

export const objectRemoverSteps = [
  {
    title: 'Upload your Image',
    description:
      'Choose an image and let AI detect elements you want to remove.',
    lightImage: '/steps/remover-light-1.png',
    darkImage: '/steps/remover-dark-1.png',
  },
  {
    title: 'Erase Unwanted Objects',
    description:
      'Remove backgrounds, people, or objects seamlessly while preserving image quality.',
    lightImage: '/steps/remover-light-2.png',
    darkImage: '/steps/remover-dark-2.png',
  },
  {
    title: 'Save & Use',
    description:
      'Download the edited image, ready to use anywhere, personally or professionally. ',
    lightImage: '/steps/remover-light-3.png',
    darkImage: '/steps/remover-dark-3.png',
  },
];

export const objectReplacerSteps = [
  {
    title: 'Upload your Image',
    description:
      'Select an image you want to modify, whether it’s swapping objects or changing backgrounds.',
    lightImage: '/steps/replacer-light-1.png',
    darkImage: '/steps/replacer-dark-1.png',
  },
  {
    title: 'Identify & Replace',
    description:
      'Mark the elements to change, and let AI seamlessly swap, adjust, or enhance them.',
    lightImage: '/steps/replacer-light-2.png',
    darkImage: '/steps/replacer-dark-2.png',
  },
  {
    title: 'Save & Apply',
    description:
      'Download your updated image, ready for any creative or professional use.',
    lightImage: '/steps/replacer-light-3.png',
    darkImage: '/steps/replacer-dark-3.png',
  },
];

export const brandbookSteps = [
  {
    title: 'Define your Brand',
    description: 'Enter key details like name, USP, target audience and logo.',
    lightImage: '/steps/brandbook-light-1.png',
    darkImage: '/steps/brandbook-dark-1.png',
  },
  {
    title: 'Customize & Refine',
    description:
      'Adjust logo, sections, and content and colours to align with your vision.',
    lightImage: '/steps/brandbook-light-2.png',
    darkImage: '/steps/brandbook-dark-2.png',
  },
  {
    title: 'Download & Share',
    description:
      'Save your brandbook, ready to guide your brand’s identity across multiple platforms.',
    lightImage: '/steps/brandbook-light-3.png',
    darkImage: '/steps/brandbook-dark-3.png',
  },
];

export const podcastSteps = [
  {
    title: 'Enter your Prompt',
    description: 'Provide  your topic, theme, or concept to set the direction.',
    lightImage: '/steps/podcast-light-1.png',
    darkImage: '/steps/podcast-dark-1.png',
  },
  {
    title: 'Choose Voices',
    description:
      'Assign unique AI-generated voices to bring your story to life.',
    lightImage: '/steps/podcast-light-2.png',
    darkImage: '/steps/podcast-dark-2.png',
  },
  {
    title: 'Generate & Refine',
    description:
      'AI creates the script, which you can review and make adjustments.',
    lightImage: '/steps/podcast-light-3.png',
    darkImage: '/steps/podcast-dark-3.png',
  },
  {
    title: 'Download & Share',
    description: 'Save your final podcast and share it wherever you like.',
    lightImage: '/steps/podcast-light-4.png',
    darkImage: '/steps/podcast-dark-4.png',
  },
];

export const socialMediaSteps = [
  {
    title: 'Choose your Platform',
    description: 'Select where you want to share, whether it’s LinkedIn, or X.',
    lightImage: '/steps/social-light-1.png',
    darkImage: '/steps/social-dark-1.png',
  },
  {
    title: 'Provide Details',
    description: 'Enter topics, tone, and language to tailor your content.',
    lightImage: '/steps/social-light-2.png',
    darkImage: '/steps/social-dark-2.png',
  },
  {
    title: 'Refine & Preview',
    description: 'Review the generated content and tweak it to perfection.',
    lightImage: '/steps/social-light-3.png',
    darkImage: '/steps/social-dark-3.png',
  },
  {
    title: 'Publish & Share',
    description:
      'Post instantly or save it for later— seamlessly from our platform.',
    lightImage: '/steps/social-light-4.png',
    darkImage: '/steps/social-dark-4.png',
  },
];

export const stickerMakerSteps = [
  {
    title: 'Connect to Telegram',
    description:
      'Link your Telegram account to start creating and sharing stickers instantly.',
    lightImage: '/steps/sticker-light-1.png',
    darkImage: '/steps/sticker-dark-1.png',
  },
  {
    title: 'Add Image & Wait',
    description:
      'Upload your image, and let the AI process it into a high-quality sticker.',
    lightImage: '/steps/sticker-light-2.png',
    darkImage: '/steps/sticker-dark-2.png',
  },
  {
    title: 'Save & Share',
    description:
      'Easily send your new sticker directly to your Telegram chats or sticker packs.',
    lightImage: '/steps/sticker-light-3.png',
    darkImage: '/steps/sticker-dark-3.png',
  },
]

export const imageToImageSteps = [
  {
    title: 'Upload Image',
    description:
      "Start by uploading your image. Whether it's a sketch, photo, or design draft.",
    lightImage: '/steps/image-to-image-light-1.svg',
    darkImage: '/steps/sticker-dark-1.png',
  },
  {
    title: 'Choose Style',
    description:
      'Browse and apply a variety of styles to give your image a fresh new look.',
    lightImage: '/steps/image-to-image-light-2.svg',
    darkImage: '/steps/sticker-dark-2.png',
  },
  {
    title: 'Save & Share with Ease',
    description:
      'Download your transformed image and share it with the world in just a click.',
    lightImage: '/steps/image-to-image-light-3.svg',
    darkImage: '/steps/sticker-dark-3.png',
  },
];
